//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

/* global ActiveXObject: false */
import universalImageActionsRevealTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-reveal.html';

(function () {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsReveal', [
    function () {
      return {
        restrict: 'E',
        scope: {},
        require: '^universalImageActionsModal',
        template: universalImageActionsRevealTemplate,
        controller: [
          '$scope',
          '$window',
          'SyndicationService',
          'TrackingService',
          'UniversalImageActionsHelpers',
          'UniversalImageActionsItemType',
          'UniversalImageActionsApiService',
          'UniversalImageActionsService',
          function (
            $scope,
            $window,
            SyndicationService,
            TrackingService,
            UniversalImageActionsHelpers,
            UniversalImageActionsItemType,
            UniversalImageActionsApiService,
            UniversalImageActionsService,
          ) {
            const launchOptions =
              UniversalImageActionsService.getCurrentLaunchOptions();
            const universalItemId = launchOptions.getUniversalItemId();
            let hasEditedShop = false;
            const SHOP_BUTTON_DEFAULT_TEXT = 'SHOP';
            const BASE_PREVIEW_URL = `${crl8.session.baseUrls.reveal_v1}/`;
            const TRACKING_CATEGORY =
              UniversalImageActionsHelpers.getTrackingCategory(
                UniversalImageActionsService.getCurrentPage(),
              );
            const params = {};

            $scope.model = {
              widgetId: null,
              embedCode: null,
              settings: {
                autoShowProducts: false,
                shopButtonText: SHOP_BUTTON_DEFAULT_TEXT,
                stretchToFit: false,
                activeProductIcon: 'tag',
              },
              defaults: {
                shopButtonText: SHOP_BUTTON_DEFAULT_TEXT,
              },
              currentlyInWorkflow:
                !!UniversalImageActionsService.getCurrentWorkflow(),
              outstandingAsyncAction: null,
            };

            $scope.model.close = function () {
              $scope.$emit('uia:modal:close');
            };

            $scope.model.copyToClipboardClicked = function () {
              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                TrackingService.ACTION_REVEAL,
                'Copy',
              );
            };

            // Allow the user to preview their currently configured Reveal. We'll
            // open a new window pointing to a dedicated preview page
            $scope.model.openPreviewWindow = function () {
              const previewWindowUrl =
                `${BASE_PREVIEW_URL + $scope.model.widgetId}/preview` +
                `?autoShowProducts=${
                  $scope.model.settings.autoShowProducts
                }&stretchToFit=${
                  $scope.model.settings.stretchToFit
                }&shopButtonText=${
                  $scope.model.settings.shopButtonText
                }&activeProductIcon=${$scope.model.settings.activeProductIcon}`;
              $window.open(previewWindowUrl);
            };

            // Parse the supplied embedCode string and make it configurable. For
            // example, we have a checkbox for autoShowProducts. When the value
            // of the checkbox is updated, we update the string to reflect that.
            $scope.model.settings.updateAutoShowProductsSetting = function () {
              $scope.model.embedCode = $scope.model.embedCode.replace(
                /data-auto-show-products="(false|true)"/,
                `data-auto-show-products="${$scope.model.settings.autoShowProducts}"`,
              );

              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                TrackingService.ACTION_REVEAL,
                'AutoShow',
              );
            };

            $scope.model.settings.updateActiveProductIconSetting = function () {
              $scope.model.settings.activeProductIcon =
                $scope.model.settings.activeProductIcon.replace(/"/g, "'");
              $scope.model.embedCode = $scope.model.embedCode.replace(
                /data-active-product-icon=".*?"/,
                `data-active-product-icon="${$scope.model.settings.activeProductIcon}"`,
              );

              if (!hasEditedShop) {
                TrackingService.recordEvent(
                  TRACKING_CATEGORY,
                  TrackingService.ACTION_REVEAL,
                  'SpatialTagIcon',
                );
                hasEditedShop = true;
              }
            };

            $scope.model.settings.updateShopButtonTextSetting = function () {
              $scope.model.settings.shopButtonText =
                $scope.model.settings.shopButtonText.replace(/"/g, "'");
              $scope.model.embedCode = $scope.model.embedCode.replace(
                /data-shop-button-text=".*?"/,
                `data-shop-button-text="${$scope.model.settings.shopButtonText}"`,
              );

              if (!hasEditedShop) {
                TrackingService.recordEvent(
                  TRACKING_CATEGORY,
                  TrackingService.ACTION_REVEAL,
                  'CTA',
                );
                hasEditedShop = true;
              }
            };

            $scope.model.settings.updateStretchToFitSetting = function () {
              $scope.model.embedCode = $scope.model.embedCode.replace(
                /data-stretch-to-fit="(false|true)"/,
                `data-stretch-to-fit="${$scope.model.settings.stretchToFit}"`,
              );

              $scope.model.embedCode = $scope.model.embedCode.replace(
                / width: (auto|100%) !important/,
                ` width: ${$scope.model.settings.stretchToFit ? '100%' : 'auto'} !important`,
              );

              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                TrackingService.ACTION_REVEAL,
                'Fill',
              );
            };

            //
            // Initialization
            //
            $scope.model.outstandingAsyncAction = 'getEmbedCode';
            params.overrideImageUrl =
              UniversalImageActionsService.getCanonicalImageUrl();

            $scope.$on('copy-button:copied', (e) => {
              $scope.model.hasCopiedLink = true;
              e.stopPropagation();
            });

            UniversalImageActionsApiService.getRevealEmbedCodeAsync(
              universalItemId,
              params,
            )
              .then((result) => {
                $scope.model.embedCode = result.embedCode.trim();
                $scope.model.widgetId = result.widgetId;

                if (
                  launchOptions.getItemType() ===
                  UniversalImageActionsItemType.syndication
                ) {
                  SyndicationService.saveUserImageActivity(
                    launchOptions.getItemId(),
                    'reveal',
                  );
                }

                TrackingService.recordEvent(
                  TRACKING_CATEGORY,
                  TrackingService.ACTION_REVEAL,
                  'GenerateEmbedCode',
                );
              })
              .finally(() => {
                $scope.model.outstandingAsyncAction = null;
              });
          },
        ],
        link(scope, element, attrs, universalImageActionsModalCtrl) {
          scope.model.currentlyInWorkflow =
            universalImageActionsModalCtrl.currentlyInWorkflow();

          // When the user clicks on the embed code text in the modal,
          // we'll automatically select all of the text for them. Note
          // that we unbind mouseup here because Chrome will deselect
          // text on mouseup after the focus event fires.
          angular.element('.widget-embed-code-container').focus(function () {
            const elem = angular.element(this);
            elem.select();
            elem.mouseup(() => {
              elem.unbind('mouseup');
              return false;
            });
          });
        },
      };
    },
  ]);
})();
